import EmployeeContractDetails from "./employee-contract-details";
import EmployeeContractsList from "./employee-contract-list";


function EmployeeContracts({ employee, employeeId, subsubpage }) {
  if(subsubpage) {
    return <EmployeeContractDetails employeeId={employeeId} employee={employee} contractId={subsubpage === 'new' ? 'new' : parseInt(subsubpage)} />
  } else {
    return <EmployeeContractsList employeeId={employeeId} />
  }
}

export default EmployeeContracts;